// src/context/SearchModalContext.js

import { createContext, useContext } from "react";

export const SearchModalContext = createContext();

export const useSearchModal = () => useContext(SearchModalContext);
